var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-10"},[_c('BlogTemplate',_vm._b({},'BlogTemplate',_vm.entry,false),[_c('div',{staticClass:"rich-text",domProps:{"innerHTML":_vm._s(_vm.entry.textContent)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }